import { type ChangeEvent, useState } from 'react';
import type {
  IDropdownMenuInternalProps,
  ITextFieldDropdownMenu
} from 'libs/design-system/src/types/Dropdown/dropdown_menu/dropdown-menu';
import { useAutoFocus } from '../../../../hooks/useAutoFocus';
import { Input } from '../../../Input';
import { Button } from '../../../Button';
import styles from '../filter-input-field.module.scss';

export const TextField = (props: ITextFieldDropdownMenu & IDropdownMenuInternalProps) => {

  const { closeDropdown } = (props as IDropdownMenuInternalProps);

  const {
    lang, fieldName, placeholder,
    onChangeHandler, onApplyHandler,
    applyBtnText, errorMsg, closeOnSubmit = true
  } = props as ITextFieldDropdownMenu;

  const [inputValue, setInputValue] = useState("");
  const inputRef = useAutoFocus<HTMLInputElement>();

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    onChangeHandler?.(e);
    setInputValue(e.target.value);
  };

  const handleApply = () => {
    closeOnSubmit && closeDropdown?.();
    onApplyHandler?.(inputValue);
  };

  const handleFocus = (e: React.FocusEvent<HTMLInputElement>) => {
    setTimeout(() => {
      e.target.scrollIntoView({ block: 'center', behavior: 'smooth' });
    }, 300);
  };

  return (
    <div className={styles['filter-field-box']}>
      <Input
        ref={inputRef}
        name={fieldName}
        onChange={handleChange}
        onFocus={handleFocus}
        placeholder={placeholder}
        error={errorMsg}
        status={errorMsg ? 'error' : 'default'}
      />

      <Button
        size='md'
        text={applyBtnText || (lang === 'ar' ? "تطبيق" : "Apply")}
        disabled={!inputValue || !!errorMsg}
        onClickHandler={handleApply}
      />
    </div>
  )
}
